import { classes } from "../variables/classes"

export const initInputGroup = () => {
  // #otherAmount is handled a little differently - keeps active class until another donation amount button is clicked
  document.querySelectorAll('.input-group .form-control:not(#otherAmount)').forEach(el => {
    el.addEventListener('focus', e => {
      el.parentElement.classList.add(classes.activeClass)
    })

    el.addEventListener('blur', e => {
      el.parentElement.classList.remove(classes.activeClass)
    })
  })
}